<template>
  <div class="page newpage" style="margin:0;">
    <div class="password_top flex-r-s-c">
      <van-icon name="down" @click="backPath" />
      <span style="margin-left: 3.04rem;">重置密码</span>
    </div>
    <div class="login_form password_form flex-c-c-c ">
      <div class="login_from_box">
        <van-form style="margin-left: 0.2rem;" @submit="onSubmit">
          <div class="password_label">输入手机号</div>
          <van-field v-model="loginForm.mobile" type="tel" name="mobile" placeholder="请输入手机号" maxlength="11"
                     :rules="[{ required: true, message: '' }]"
          />
          <div class="password_label">输入验证码</div>
          <van-field v-model="loginForm.code" type="digit" class="van-field" name="code" placeholder="请输入验证码"
                     maxlength="6" :rules="[{ required: true, message: '' }]"
          >
            <template #extra>
              <van-count-down v-if="isSend" style="line-height: 1.23rem;margin-right: 0.1rem;" :time="time"
                              format="ss 秒重新发送" @finish="finish"
              />
              <div v-else class="send_message" @click="sendMessage">获取验证码</div>
            </template>
          </van-field>
          <div class="password_label">输入登录密码</div>
          <van-field v-model="loginForm.password" :type="showMm1 ? 'text':'password'" class="van-field" name="password"
                     placeholder="请输入密码" :rules="[{ required: true, message: '' }]"
          >
            <template #extra>
              <div class="flex-r-c-c" style="padding-right: 0.43rem;">
                <van-icon v-if="showMm1" name="eye-o" size="0.43rem" @click="showMm1 = !showMm1" />
                <van-icon v-if="!showMm1" name="closed-eye" size="0.43rem" @click="showMm1 = !showMm1" />
              </div>
            </template>
          </van-field>
          <div class="password_label">确认登录密码</div>
          <van-field v-model="loginForm.copyPassword" :type="showMm2 ? 'text':'password'" class="van-field"
                     name="copyPassword" placeholder="请输入密码" :rules="[{ required: true, message: '' }]"
          >
            <template #extra>
              <div class="flex-r-c-c" style="padding-right: 0.43rem;">
                <van-icon v-if="showMm2" name="eye-o" size="0.43rem" @click="showMm2 = !showMm2" />
                <van-icon v-if="!showMm2" name="closed-eye" size="0.43rem" @click="showMm2 = !showMm2" />
              </div>
            </template>
          </van-field>
          <div class="password_tips">
            <span style="color: #E31F2F;">*</span>密码不得少于8位数，且必须是数字和字母的混合
          </div>
          <div class="login_sub">
            <van-button round block :loading="loading" type="info" loading-text="确认中..." native-type="submit"
                        color="#0767ab" style="font-size: 0.43rem;"
            >确认设置
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import JSEncrypt from 'jsencrypt'
import { Base64 } from 'js-base64'
import './index.scss'
// 接口
import { sendSms_password, reset_password, login_password, rsaPublicKey } from '@/api/user'
export default {
  data() {
    return {
      isSend: false,
      loading: false,
      time: 60 * 1000,
      loginForm: { mobile: '', code: '', password: '', copyPassword: '', openId: '', companyCategoryId: 1 },
      showMm1: false,
      showMm2: false
    }
  },
  created() {
    this.loginForm.openId = this.$route.query.openid
    this.loginForm.mobile = this.$route.query.mobile
  },
  methods: {
    backPath() { window.history.back() },
    getPublicKey(callable) {
      rsaPublicKey().then((res) => {
        if (res.data) {
          callable(res.data.publicKey)
        } else {
          this.$message.warning('获取公钥失败，请联系管理员')
        }
      })
    },
    // 点击登录
    onSubmit(values) {
      var that = this
      console.log(this.loginForm)
      that.loading = true
      // 验证密码是否一致
      if (that.loginForm.password === that.loginForm.copyPassword) {
        var password
        const encrypt = new JSEncrypt()
        that.getPublicKey(function (publicKey) {
          encrypt.setPublicKey(publicKey)
          const data = encrypt.encrypt(that.loginForm.password)
          password = Base64.encode(data)
          const pamrs = {
            code: that.loginForm.code,
            mobile: that.loginForm.mobile,
            openId: that.loginForm.openId,
            password: password
          }
          reset_password(pamrs).then(resx => {
            login_password({ mobile: that.loginForm.mobile, openId: that.loginForm.openId, password: password }).then(res => {
              res.data.openid = that.loginForm.openId
              res.data.ref = that.url
              that.$utils.storeUserInfo(that.$store, res.data)
              that.loading = false
              that.$utils.localLogin(that, res.data, 'login_pet')
            }).catch(err2 => {
              console.log(err2)
              that.loading = false
            })
          }).catch(err => {
            console.log(err)
            that.loading = false
          })
        })
      } else {
        that.loading = false
        that.$toast({ message: '密码输入不一致！', duration: 3 * 1000 })
      }
    },
    // 发送短信
    sendMessage() {
      if (this.loginForm.mobile.length === 11) {
        const parms = { mobile: this.loginForm.mobile, tempId: '1046' }
        sendSms_password(parms).then(res => {
          this.$toast({ message: '已发送！', duration: 3 * 1000 })
          this.isSend = true
        })
      } else {
        this.$toast({ message: '请输入手机号', position: 'top', duration: 3 * 1000 })
      }
    },
    // 倒计时结束触发
    finish() { this.isSend = false }

  }
}
</script>

<style>
.newpage {
  background: url("https://oss.xiaoyi120.com/shop2.0/login/login_bg.png");
  /* background: url("https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/snake_login_bg.png"); */
  background-size: 10rem 10.13rem;
  background-repeat: no-repeat;
}
</style>
